import axios from 'axios';
//import * as CALLING_FUNCTIONALITY from 'app/main/apps/calling/functionality/initSamuraiCallSession';

export const DISPLAY_UI_CALLING = '[CALLING] DISPLAY UI WHEN USER IS CALLING';
export const CALLING_INIT = '[CALLING] CALLING INITIALIZATION';
export const CALLING_END = '[CALLING] END VOICE CALL';
export const NOTIFICATION_TUNE = '[CALLING] NOTIFICATION TUNE';
export const IS_VIDEO_CALL = '[CALLING] IS VIDEO CALL';
export const IS_CALL_ACCEPTED = '[CALLING] IS CALL ACCEPTED';
export const CALL_INFORMATIONS = '[CALLING] CALL INFORMATIONS';
export const DECLINE_CALL = '[CALLING] DECLINE CALL';
export const DISPLAY_USERS_LIST = '[CALLING] DISPLAY USERS LIST';
export const SET_TOKBOX_DETAIL = '[CALLING] SET TOKBOX DETAIL';
export const JOINING_SESSION = '[CALLING] JOINING SESSION';
export const SET_AUDIO_OUTPUTS = '[CALLING] SET AUDIO OUTPUTS';
export const SET_AUDIO_INPUTS = '[CALLING] SET AUDIO INPUTS';
export const SET_VIDEO_INPUTS = '[CALLING] SET VIDEO INPUTS';
export const SET_AUDIO_OUTPUT = '[CALLING] SET AUDIO OUTPUT';
export const SET_AUDIO_INPUT = '[CALLING] SET AUDIO INPUT';
export const SET_VIDEO_INPUT = '[CALLING] SET VIDEO INPUT';
export const RIGHT_PANEL_DISPLAYED = '[CALLING] RIGHT PANEL DISPLAYED';
export const SET_PUBLISHER = '[CALLING] SET PUBLISHER';
export const SET_VIDEO_EFFECT = '[CALLING] SET VIDEO EFFECT';
export const SET_SCREENSHARING = '[CALLING] SET SCREENSHARING';
export const DRAW_CLEAR_SCREEN = '[CALLING] DRAW CLEAR SCREEN';
export const DRAW_CLEAR_SCREEN_RESET = '[CALLING] DRAW CLEAR SCREEN RESET';
export const UPDATE_BACKGROUND_VIDEO = '[CALLING] UPDATE BACKGROUND VIDEO';
export const GET_BACKGROUND_VIDEO = '[CALLING] GET BACKGROUND VIDEO';
export const DELETE_BACKGROUND_VIDEO = '[CALLING] DELETE BACKGROUND VIDEO';
export const DRAWING_MODE = '[CALLING] DRAWING MODE';
export const SET_SESSION_ID = '[CALLING] SET_SESSION_ID';
export const ADD_USER_TO_GROUP = '[CALLING] ADD USER TO GROUP';
export const UPDATE_CHAT_ID = '[CALLING] UPDATE CHAT ID';

export function updateChatId(data){
	return {
		type: UPDATE_CHAT_ID,
		payload: data,
	};
}

export function addUserToGroup(data){
	return {
		type: ADD_USER_TO_GROUP,
		payload: data,
	};
}

export function setSessionId(sessionId){
	return {
		type: SET_SESSION_ID,
		payload: sessionId,
	};
}

export function deleteBackground(imgId) {
	return async (dispatch, getState) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];

		const URL = process.env.REACT_APP_SERVER + '/api/profile/get-update-background-image'
		const request = await axios.delete(URL, {
								headers: { Authorization: `Token ${token}` },
								data: {
									id: parseInt(imgId)
								}
							  });
		
			dispatch({
				type: DELETE_BACKGROUND_VIDEO,
				data: request
			});

			dispatch(getBackgroundVideo())
	}

}

export function getBackgroundVideo(){

	let current_user = JSON.parse(localStorage.getItem('current_user'));
	let token = current_user['authToken'];

	const request = axios.get(process.env.REACT_APP_SERVER + '/api/profile/get-update-background-image', {
		headers: { Authorization: `Token ${token}` },
		params: {}
	});

	return dispatch =>
		request.then(response => {
			console.log("get all uploaded background", response)
			return dispatch({
				type: GET_BACKGROUND_VIDEO,
				payload: response.data.data,
			});
		});

}

export function updateBackgroundVideo(data){

	let current_user = JSON.parse(localStorage.getItem('current_user'));
	let token = current_user['authToken'];

	const headersToken = {
		'Content-Type': 'application/json',
		headers: {"Authorization": `Token ${token}`}
	};

	const request = axios.post(process.env.REACT_APP_SERVER + '/api/profile/get-update-background-image', data, headersToken );

	return dispatch =>
		request.then(response => {
			dispatch(getBackgroundVideo())
			return dispatch({
				type: UPDATE_BACKGROUND_VIDEO,
				//payload: data,
			});
			
		});

	
}

export function setDrawingMode(bool){
	return {
		type: DRAWING_MODE,
		payload: bool,
	};
}

export function drawClearSreenReset(){
	return {
		type: DRAW_CLEAR_SCREEN_RESET,
	};
}

export function drawClearSreen(){
	return {
		type: DRAW_CLEAR_SCREEN,
	};
}

export function setScreenSharing(data){
	return {
		type: SET_SCREENSHARING,
		payload: data,
	};
}

export function setVideoEffect(data){
	return {
		type: SET_VIDEO_EFFECT,
		payload: data,
	};
}

export function setPublisher(publisher){
	return {
		type: SET_PUBLISHER,
		payload: publisher,
	};
}

export function setAudioInput(id)
{
	return {
		type: SET_AUDIO_INPUT,
		payload: id,
	};
}
export function setAudioOutput(id)
{
	return {
		type: SET_AUDIO_OUTPUT,
		payload: id,
	};
}
export function setVideoInput(id)
{
	return {
		type: SET_VIDEO_INPUT,
		payload: id,
	};
}

export function setVideoInputs(inputs)
{
	return {
		type: SET_VIDEO_INPUTS,
		payload: inputs,
	};
}
export function setAudioInputs(inputs)
{
	return {
		type: SET_AUDIO_INPUTS,
		payload: inputs,
	};
}
export function setAudioOutputs(outputs)
{
	return {
		type: SET_AUDIO_OUTPUTS,
		payload: outputs,
	};
}

export function joiningSession(data) {
	return {
		type: JOINING_SESSION,
		payload: data,
	};
}

export function setTokBoxDetails(data) {
	return {
		type: SET_TOKBOX_DETAIL,
		payload: data,
	};
}

export function rightPanelDisplayed(bool,users) {
	return {
		type: RIGHT_PANEL_DISPLAYED,
		payload: bool,
		panel:users,
	};
}
export function displayUserDuringCall(bool) {
	return {
		type: DISPLAY_USERS_LIST,
		payload: bool,
	};
}

export function declineCall() {
	return {
		type: DECLINE_CALL,
	};
}

export function displayUiWhenCalling(bool, _data) {
	return {
		type: DISPLAY_UI_CALLING,
        payload: bool,
        data:_data
	};
}

export function endVoiceCall(){
	return {
		type: CALLING_END
	};
}

export function callingInitialization(chat){
	return {
		type: CALLING_INIT,
		payload: chat
	};
}

//play or stop notification tune
export function notificationTuneWhenCalling(bool){
	return {
		type: NOTIFICATION_TUNE,
		payload: bool
	};
}

export function isVideoCall(bool){
	return {
		type: IS_VIDEO_CALL,
		payload: bool
	};
}

export function isCallAccepted(bool){
	return {
		type: IS_CALL_ACCEPTED,
		payload: bool
	};
}

export function callInfos(data, join){
	let caller = data.chatAllUser.filter(u => u.isCaller === true)

	let current_user = JSON.parse(localStorage.getItem('current_user'));
	let authToken = current_user['authToken'];

	// join !== true && CALLING_FUNCTIONALITY.callingSessionCreation(
    //     caller[0].id,
    //     data.chatId,
    //     data.chat_users ? data.chat_users : data.chatAllUser,
    //     data.callLogId,
	// 	authToken
    // )
	return {
		type: CALL_INFORMATIONS,
		payload: data
	};
}
